import { c as _c } from "react/compiler-runtime";
import { useHotelreservecardCancellationModal } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-cancellation-modal/hotel-reserve-card-cancellation-modal.hook";
import { HotelReserveCardCancellationModalType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-cancellation-modal/hotel-reserve-card-cancellation-modal.types";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { Skeleton } from "@website/ui/skeleton";
import { dateFormat } from "@website/utils/date-format";
import { numberSeparator } from "@website/utils/number-separator";
import { useRouter } from "next/router";
import { FC } from "react";
export const HotelReserveCardCancellationModal: FC<HotelReserveCardCancellationModalType> = properties => {
  const $ = _c(24);
  const router = useRouter();
  const {
    title,
    buttonProps,
    modalProps,
    policies,
    isLoading
  } = useHotelreservecardCancellationModal(properties);
  const {
    cancellationPolicies,
    bundleId,
    isBundleSelected,
    title: modalTitle
  } = properties;
  const t0 = modalTitle ?? title;
  let t1;
  if ($[0] !== t0) {
    t1 = <div className="flex"><h3 className="text-headline-6">{t0}</h3></div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== cancellationPolicies || $[3] !== isBundleSelected || $[4] !== router) {
    t2 = cancellationPolicies?.length && !isBundleSelected && <table><thead className="bg-dim-background"><tr><th className="text-body-2 border px-4 py-3 text-left rtl:text-right" scope="col">شرایط زمانی کنسلی</th><th className="text-body-2 border px-4 py-3" scope="col">هزینه کنسلی</th></tr></thead><tbody>{cancellationPolicies && cancellationPolicies?.length && cancellationPolicies.map(item => <tr key={`${item.from}_${item.amount}`}><td className="text-caption border p-4 text-left rtl:text-right">{item?.from && dateFormat(item.from, {
              locale: router.locale,
              template: "DDD"
            })}</td><td className="text-caption border p-4 text-center rtl:text-right">{item?.amount ? `${numberSeparator(Math.trunc(item.amount / 10))} تومان` : ""}</td></tr>)}</tbody></table>;
    $[2] = cancellationPolicies;
    $[3] = isBundleSelected;
    $[4] = router;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== bundleId || $[7] !== isLoading) {
    t3 = isLoading && bundleId && <Skeleton height={250} />;
    $[6] = bundleId;
    $[7] = isLoading;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== policies) {
    t4 = policies && <ul className="px-2">{policies?.map(_temp)}</ul>;
    $[9] = policies;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <div className="my-6 w-full rounded-lg border">{t2}{t3}{t4}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t1 || $[16] !== t5) {
    t6 = <div className="max-h-96 overflow-auto lg:w-[400px]">{t1}{t5}</div>;
    $[15] = t1;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== buttonProps) {
    t7 = <Button {...buttonProps} />;
    $[18] = buttonProps;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== modalProps || $[21] !== t6 || $[22] !== t7) {
    t8 = <Modal {...modalProps}>{t6}{t7}</Modal>;
    $[20] = modalProps;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
function _temp(p) {
  return <li className={`mb-6 ${/[\u0600-\u06FF]/.test(p) ? "" : "text-left"}`} dangerouslySetInnerHTML={{
    __html: p
  }} key={p} />;
}